<template>
  <svg
    width="16"
    height="21"
    viewBox="0 0 16 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.1062 14.7059C13.7263 13.6427 12.8894 12.7033 11.7251 12.0332C10.5608 11.3632 9.13423 11 7.66667 11C6.19911 11 4.77255 11.3632 3.60826 12.0332C2.44396 12.7033 1.60699 13.6427 1.22716 14.7059"
      stroke="#666666"
      stroke-width="2"
      stroke-linecap="round"
    />
    <circle
      cx="7.66732"
      cy="4.33333"
      r="3.33333"
      stroke="#666666"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>
